import myChrome from "../../../../src/images/js/my_chrome.png";
import chromeShare from "../../../../src/images/js/chrome_share.png";
import * as React from 'react';
export default {
  myChrome,
  chromeShare,
  React
};